export function merge(array, items, positions) {
  positions.forEach((position) => {
    const item = items.shift();
    if (position - 1 > array.length) return;
    if (!item) return;
    array.splice(position - 1, 0, item);
  });
  return array;
}
